import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from 'redux-persist-indexeddb-storage';
import { persistStore, persistReducer} from 'redux-persist';
import authReducer from "./authSlice";
import articleReducer from "./articleSlice";
import blogReducer from "./blogSlice";
import statReducer from "./statSlice";
import modalReducer from './modalSlice';
import toolboxReducer from "./toolboxPartnerSlice";
import awardReducer from "./awardSlice";
import videoReducer from "./videoSlice";
import paramsReducer from "./paramSlice";
import hiringReducer from "./hiringSlice";
import hiringContactReducer from "./hiringContactSlice";
import hotelReducer from "./hotelSlice";

const persistConfig = {
  key: 'root',
  storage: storage("plateformDBv2026.01"),  
};

const rootReducer = combineReducers({
  auth: authReducer,
  articles: articleReducer,
  blogs: blogReducer,
  stats: statReducer,
  modal: modalReducer,
  toolbox: toolboxReducer,
  awards: awardReducer,
  video:videoReducer,
  params:paramsReducer,
  hirings:hiringReducer,
  hiringContacts:hiringContactReducer,
  hotels:hotelReducer
});

const persistedReducer = persistReducer(persistConfig,rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware:(getDefaultMiddleware)=>
      getDefaultMiddleware({
          serializableCheck: {
          ignoredActions: ['persist/FLUSH', 'persist/REHYDRATE', 'persist/PAUSE', 'persist/PURGE', 'persist/REGISTER'],
      },
  }),
});

export const persistor = persistStore(store);
